<template>
    <div>
        <Header></Header>
    </div>
</template>

<script>
import Header from "@/components/logs/Header"

export default {
    components: {
        Header
    }
}
</script>

<style scoped>

</style>